import React, { useEffect, useState } from 'react';

const Snowflakes = ({ intensity = 'medium' }) => {
  const [snowflakes, setSnowflakes] = useState([]);

  useEffect(() => {
    // Determine number of snowflakes based on intensity
    // Reduce for mobile to avoid visual clutter
    const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
    const baseCount = intensity === 'light' ? 15 : intensity === 'medium' ? 25 : 40;
    const flakeCount = isMobile ? Math.floor(baseCount * 0.6) : baseCount;
    
    // Generate snowflakes with random properties
    const flakes = Array.from({ length: flakeCount }, (_, i) => ({
      id: i,
      left: Math.random() * 100, // Random horizontal position (%)
      animationDuration: 10 + Math.random() * 20, // 10-30 seconds fall time
      opacity: 0.2 + Math.random() * 0.5, // 0.2 to 0.7 opacity (more subtle)
      size: 6 + Math.random() * 8, // 6-14px size (smaller)
      delay: Math.random() * 5, // 0-5 second delay before starting
      drift: -20 + Math.random() * 40, // -20px to 20px horizontal drift
    }));
    
    setSnowflakes(flakes);
  }, [intensity]);

  return (
    <div 
      className="snowflakes-container"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 9999,
        overflow: 'hidden'
      }}
    >
      {snowflakes.map((flake) => (
        <div
          key={flake.id}
          className="snowflake"
          style={{
            position: 'absolute',
            top: '-20px',
            left: `${flake.left}%`,
            width: `${flake.size}px`,
            height: `${flake.size}px`,
            background: 'white',
            borderRadius: '50%',
            opacity: flake.opacity,
            animation: `snowfall ${flake.animationDuration}s linear infinite`,
            animationDelay: `${flake.delay}s`,
            boxShadow: '0 0 5px rgba(255, 255, 255, 0.3)',
            '--drift': `${flake.drift}px`,
          }}
        />
      ))}
      
      <style>{`
        @keyframes snowfall {
          0% {
            transform: translateY(0) translateX(0);
          }
          50% {
            transform: translateY(50vh) translateX(var(--drift));
          }
          100% {
            transform: translateY(100vh) translateX(0);
          }
        }
      `}</style>
    </div>
  );
};

export default Snowflakes;
